import React from 'react';
import pt from 'prop-types';
import cn from 'classnames';
import PreviewImage from '../../PreviewImage';
import { formattedSeason } from '../../../utils/functions';
import styles from './PastImagesQuickOrder.module.scss';

function formatPrice(option) {
  if (!option) return '';
  const priceRecord = option.prices && option.prices[0];
  const price = priceRecord && priceRecord.price;
  if (price == null) return '';
  return `$${Number(price).toFixed(2)}`;
}

export default function PastImageOption({
  studentImage,
  options,
  backgrounds,
  defaultBackground,
  selection,
  onSelectOption,
  onSelectBackground,
}) {
  const watermark = studentImage.watermarkUrl || studentImage.imageUrl;
  const selectedOptionId = selection?.optionId || null;
  const selectedBackgroundId = selection?.backgroundId || defaultBackground?.id || null;
  const previewBackground = backgrounds.find((bg) => bg.id === selectedBackgroundId)
    || defaultBackground
    || backgrounds[0]
    || null;

  return (
    <div className={styles.tile}>
      <div className={styles.preview}>
        <PreviewImage
          foregroundUrl={watermark}
          backgroundUrl={previewBackground?.imageUrl || ''}
          isPreviewHidden={false}
        />
      </div>
      <p className={styles.season}>{formattedSeason(studentImage.folder)}</p>

      <div className={styles.optionsList}>
        {options.map((opt) => {
          const isSelected = selectedOptionId === opt.id;
          return (
            <button
              key={opt.id}
              type="button"
              className={cn(styles.optionBtn, { [styles.optionBtnSelected]: isSelected })}
              onClick={() => onSelectOption(studentImage.id, isSelected ? null : opt.id)}
            >
              <span>{opt.name}</span>
              <span className={styles.optionPrice}>{formatPrice(opt)}</span>
            </button>
          );
        })}
      </div>

      {selectedOptionId && backgrounds.length > 0 && (
        <div className={styles.bgRow}>
          <span className={styles.bgLabel}>Background</span>
          <div className={styles.bgList}>
            {backgrounds.map((bg) => {
              const isSelected = selectedBackgroundId === bg.id;
              return (
                <button
                  key={bg.id}
                  type="button"
                  aria-label={`Background ${bg.name || bg.letter || bg.id}`}
                  title={bg.name || bg.letter || ''}
                  className={cn(styles.bgSwatch, { [styles.bgSwatchSelected]: isSelected })}
                  style={{ backgroundImage: `url(${bg.imageUrl})` }}
                  onClick={() => onSelectBackground(studentImage.id, bg.id)}
                />
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

PastImageOption.defaultProps = {
  selection: null,
  backgrounds: [],
  defaultBackground: null,
};

PastImageOption.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  studentImage: pt.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  options: pt.array.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  backgrounds: pt.array,
  // eslint-disable-next-line react/forbid-prop-types
  defaultBackground: pt.object,
  // eslint-disable-next-line react/forbid-prop-types
  selection: pt.object,
  onSelectOption: pt.func.isRequired,
  onSelectBackground: pt.func.isRequired,
};
